import { render, staticRenderFns } from "./AnimateText.vue?vue&type=template&id=4cdd4a9a&"
import script from "./AnimateText.vue?vue&type=script&lang=js&"
export * from "./AnimateText.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports